module.exports = {"id":"182166","name":"Julian Palmieri","rating":"73","photo":"./data/images/photos/4/182166.png","club":{"name":"FC Metz","logo":"./data/images/clubs/FCMetz.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianPalmieri0.json
// module id = 2240
// module chunks = 0